export default __webpack_public_path__ + "static/media/icons8-management (5).bd90a330.svg";